import React from 'react';
import { Button } from '../components/ui/button';
import { Phone, Building2, Factory, Waves, Zap, Construction, Wheat } from 'lucide-react';
import './Clientes.css';

// Selección final de clientes (2026-09): principales + secundarios con logo disponible.
// Pendientes de sumar cuando consigamos el logo real:
//   - T6 Industrial (existe TERMINAL-6-LOGO, pero es otra empresa del grupo)
//   - PBB Polisur (sin archivo)
//   - Patagonia Bioenergia (PATAGONIA-BIOENERGIA-LOGO.webp es un banner, no el logo)
const SHOW_LOGOS = true;

const Clientes = () => {
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=\u00a1Hola!%20Quiero%20conocer%20m\u00e1s%20sobre%20sus%20servicios`;

  const sectores = [
    {
      icon: <Waves size={28} />,
      nombre: 'Agua y saneamiento',
      descripcion: 'Empresas de distribución de agua potable, tratamiento de efluentes y servicios sanitarios.'
    },
    {
      icon: <Factory size={28} />,
      nombre: 'Industria química y petroquímica',
      descripcion: 'Plantas de producción, refinerías y empresas del sector energético.'
    },
    {
      icon: <Wheat size={28} />,
      nombre: 'Agroindustria',
      descripcion: 'Plantas de procesamiento de granos, aceites vegetales y producción de alimento balanceado.'
    },
    {
      icon: <Zap size={28} />,
      nombre: 'Energía',
      descripcion: 'Centrales térmicas, hidroeléctricas y proyectos de infraestructura energética.'
    },
    {
      icon: <Building2 size={28} />,
      nombre: 'Construcción',
      descripcion: 'Desarrollos inmobiliarios, edificios comerciales e institucionales.'
    },
    {
      icon: <Construction size={28} />,
      nombre: 'Minería',
      descripcion: 'Proyectos mineros y de extracción de recursos naturales.'
    }
  ];

  const clientes = [
    { nombre: 'ACA', logo: '/assets/logos/clientes/ACA-LOGO.webp' },
    { nombre: 'ACHA', logo: '/assets/logos/clientes/ACHA-LOGO.webp' },
    { nombre: 'ACINDAR', logo: '/assets/logos/clientes/ACINDAR-LOGO.webp' },
    { nombre: 'ADM', logo: '/assets/logos/clientes/ADM-LOGO.webp' },
    { nombre: 'AES', logo: '/assets/logos/clientes/AES-LOGO.webp' },
    { nombre: 'AFA', logo: '/assets/logos/clientes/AFA-LOGO.webp' },
    { nombre: 'AGD', logo: '/assets/logos/clientes/AGD-LOGO.webp' },
    { nombre: 'AGUAS SANTAFESINAS', logo: '/assets/logos/clientes/AGUAS-SANTAFESINAS-LOGO.webp' },
    { nombre: 'AIR LIQUIDE', logo: '/assets/logos/clientes/AIR-LIQUIDE-LOGO.webp' },
    { nombre: 'ALBANESI', logo: '/assets/logos/clientes/ALBANESI-LOGO.webp' },
    { nombre: 'ALGODONERA AVELLANEDA', logo: '/assets/logos/clientes/ALGODONERA-AVELLANEDA-LOGO.webp' },
    { nombre: 'AMBEV', logo: '/assets/logos/clientes/AMBEV-LOGO.webp' },
    { nombre: 'ARCOR', logo: '/assets/logos/clientes/ARCOR-LOGO.webp' },
    { nombre: 'BOORTMALT', logo: '/assets/logos/clientes/BOORTMALT-LOGO.webp' },
    { nombre: 'BUNGE', logo: '/assets/logos/clientes/BUNGE-LOGO.webp' },
    { nombre: 'BUYANOR', logo: '/assets/logos/clientes/BUYANOR-LOGO.webp' },
    { nombre: 'BUYATTI', logo: '/assets/logos/clientes/BUYATTI-LOGO.webp' },
    { nombre: 'CARGILL', logo: '/assets/logos/clientes/CARGILL-LOGO.webp' },
    { nombre: 'CCU', logo: '/assets/logos/clientes/CCU-LOGO.webp' },
    { nombre: 'CENTRAL VUELTA OBLIGADO', logo: '/assets/logos/clientes/CENTRAL-VUELTA-OBLIGADO-LOGO.webp' },
    { nombre: 'CENTRALES COSTA ATLANTICA', logo: '/assets/logos/clientes/CENTRALES-COSTA-ATLANTICA-LOGO.webp' },
    { nombre: 'COCYAR', logo: '/assets/logos/clientes/COCYAR-LOGO.webp' },
    { nombre: 'COFCO', logo: '/assets/logos/clientes/COFCO-LOGO.webp' },
    { nombre: 'CORTEVA', logo: '/assets/logos/clientes/CORTEVA-LOGO.webp' },
    { nombre: 'CPM', logo: '/assets/logos/clientes/CPM-LOGO.webp' },
    { nombre: 'DOW QUIMICA', logo: '/assets/logos/clientes/DOW-QUIMICA-LOGO.webp' },
    { nombre: 'EDECA', logo: '/assets/logos/clientes/EDECA-LOGO.webp' },
    { nombre: 'ENTRE RIOS CRUSHING', logo: '/assets/logos/clientes/ERC-LOGO.webp' },
    { nombre: 'EXPLORA', logo: '/assets/logos/clientes/EXPLORA-LOGO.webp' },
    { nombre: 'FIPLASTO', logo: '/assets/logos/clientes/FIPLASTO-LOGO-2.webp' },
    { nombre: 'GENERAL MOTORS', logo: '/assets/logos/clientes/GENERAL-MOTORS-LOGO.webp' },
    { nombre: 'GENTE DE LA PAMPA', logo: '/assets/logos/clientes/GENTE-DE-LA-PAMPA-LOGO.webp' },
    { nombre: 'GIER', logo: '/assets/logos/clientes/GIER-LOGO.webp' },
    { nombre: 'GLENCORE', logo: '/assets/logos/clientes/GLENCORE-LOGO.webp' },
    { nombre: 'JBS', logo: '/assets/logos/clientes/JBS-LOGO.webp' },
    { nombre: 'KECLON', logo: '/assets/logos/clientes/KECLON-LOGO.webp' },
    { nombre: 'LA SIBILA', logo: '/assets/logos/clientes/LA-SIBILA-LOGO.webp' },
    { nombre: 'LA VIRGINIA', logo: '/assets/logos/clientes/LA-VIRGINIA-LOGO.webp' },
    { nombre: 'LDC', logo: '/assets/logos/clientes/LDC-LOGO.webp' },
    { nombre: 'MILICIC', logo: '/assets/logos/clientes/MILICIC-LOGO.webp' },
    { nombre: 'MOLINOS AGRO', logo: '/assets/logos/clientes/MOLINOS-AGRO-LOGO.webp' },
    { nombre: 'MOLINOS CA\u00d1UELAS', logo: '/assets/logos/clientes/MOLINOS-CANUELAS-LOGO.webp' },
    { nombre: 'MOLINOS RIO DE LA PLATA', logo: '/assets/logos/clientes/MOLINOS-RIO-DE-LA-PLATA-LOGO.webp' },
    { nombre: 'MONTHELADO', logo: '/assets/logos/clientes/MONTHELADO-LOGO.webp' },
    { nombre: 'MUNDO CONSTRUCCIONES', logo: '/assets/logos/clientes/MUNDO-CONSTRUCCIONES-LOGO.webp' },
    { nombre: 'NOURYON', logo: '/assets/logos/clientes/NOURYON-LOGO.webp' },
    { nombre: 'OLEAGINOSA SAN LORENZO', logo: '/assets/logos/clientes/OLEAGINOSA-SAN-LORENZO-LOGO.webp' },
    { nombre: 'PALADINI', logo: '/assets/logos/clientes/PALADINI-LOGO.webp' },
    { nombre: 'PAMPA ENERGIA', logo: '/assets/logos/clientes/PAMPA-ENERGIA-LOGO.webp' },
    { nombre: 'PB LEINER', logo: '/assets/logos/clientes/PB-LEINER.webp' },
    { nombre: 'PEITEL', logo: '/assets/logos/clientes/PEITEL-LOGO.webp' },
    { nombre: 'PETROBRAS', logo: '/assets/logos/clientes/PETROBRAS-LOGO.webp' },
    { nombre: 'PETROQUIMICA RIO TERCERO', logo: '/assets/logos/clientes/PETROQUIMICA-RIO-TERCERO-LOGO.webp' },
    { nombre: 'PROFERTIL', logo: '/assets/logos/clientes/PROFERTIL-LOGO.webp' },
    { nombre: 'PROMAIZ', logo: '/assets/logos/clientes/PROMAIZ-LOGO.webp' },
    { nombre: 'PROTOIL SRL', logo: '/assets/logos/clientes/PROTOIL-SRL.webp' },
    { nombre: 'RENO PACK', logo: '/assets/logos/clientes/RENO-PACK-LOGO.webp' },
    { nombre: 'RENOVA', logo: '/assets/logos/clientes/RENOVA-LOGO.webp' },
    { nombre: 'RICEDAL', logo: '/assets/logos/clientes/RICEDAL-LOGO.webp' },
    { nombre: 'SANCOR', logo: '/assets/logos/clientes/SANCOR-LOGO.webp' },
    { nombre: 'SAVENCIA', logo: '/assets/logos/clientes/SAVENCIA-LOGO.webp' },
    { nombre: 'SIEMENS', logo: '/assets/logos/clientes/SIEMENS-LOGO.webp' },
    { nombre: 'SIPAR GERDAU', logo: '/assets/logos/clientes/SIPAR-GERDAU-LOGO.webp' },
    { nombre: 'SOL CONSTRUCCIONES', logo: '/assets/logos/clientes/SOL-CONSTRUCCIONES.webp' },
    { nombre: 'SYNTHON', logo: '/assets/logos/clientes/SYNTHON-LOGO.webp' },
    { nombre: 'TANONI', logo: '/assets/logos/clientes/TANONI-LOGO.webp' },
    { nombre: 'TERMINAL 6', logo: '/assets/logos/clientes/TERMINAL-6-LOGO.webp' },
    { nombre: 'TERMINAL FERTILIZANTES ARGENTINOS', logo: '/assets/logos/clientes/TERMINAL-FERTILIZANTES-ARGENTINOS-LOGO.webp' },
    { nombre: 'TGS', logo: '/assets/logos/clientes/TGS-LOGO.webp' },
    { nombre: 'UNILEVER', logo: '/assets/logos/clientes/UNILEVER-LOGO.webp' },
    { nombre: 'UNIPAR INDUPA', logo: '/assets/logos/clientes/UNIPAR-INDUPA-LOGO.webp' },
    { nombre: 'VERONICA', logo: '/assets/logos/clientes/VERONICA-LOGO.webp' },
    { nombre: 'VICENTIN', logo: '/assets/logos/clientes/VICENTIN-LOGO.webp' },
    { nombre: 'VITERRA', logo: '/assets/logos/clientes/VITERRA-LOGO.webp' },
    { nombre: 'WERK', logo: '/assets/logos/clientes/WERK-LOGO.webp' },
    { nombre: 'WINKELMANN', logo: '/assets/logos/clientes/WINKELMANN-LOGO.webp' },
    { nombre: 'YPF', logo: '/assets/logos/clientes/YPF-LOGO.webp' },
  ];

  const beneficios = [
    {
      titulo: 'Experiencia comprobada',
      descripcion: 'Más de 35 años acompañando el desarrollo industrial en Argentina.'
    },
    {
      titulo: 'Marcas líderes',
      descripcion: 'Representamos a KSB y TECNAL, fabricantes de reconocimiento mundial.'
    },
    {
      titulo: 'Soporte especializado',
      descripcion: 'Asesoramiento técnico en todas las etapas del proyecto.'
    },
    {
      titulo: 'Soluciones personalizadas',
      descripcion: 'Adaptamos cada propuesta a las necesidades específicas de cada cliente.'
    },
    {
      titulo: 'Compromiso con la calidad',
      descripcion: 'Equipos confiables que garantizan eficiencia y durabilidad.'
    },
    {
      titulo: 'Servicio post-venta',
      descripcion: 'Acompañamiento continuo para asegurar el óptimo funcionamiento de los equipos.'
    }
  ];

  return (
    <div className="clientes-container">
      {/* Hero Section */}
      <section className="clientes-hero">
        <div className="clientes-hero-content">
          <h1 className="clientes-hero-title">Nuestros Clientes</h1>
          <p className="clientes-hero-subtitle">
            Cada una de estas empresas representa una relación construida sobre confianza, compromiso y resultados.
          </p>
        </div>
      </section>

      {/* Logos de Clientes */}
      <section className="clientes-logos-section">
        <div className="container">
          {SHOW_LOGOS ? (
            <div className="clientes-logos-grid">
              {clientes.map((cliente, idx) => (
                <div key={idx} className="cliente-logo-card">
                  <img src={cliente.logo} alt={cliente.nombre} loading="lazy" className="cliente-logo" />
                </div>
              ))}
            </div>
          ) : (
            <div className="clientes-logos-placeholder">
              <p>Estamos actualizando nuestra lista de clientes. ¡Próximamente!</p>
            </div>
          )}
        </div>
      </section>

      {/* Sectores */}
      <section className="clientes-sectores-section">
        <div className="container">
          <h2 className="section-title">Sectores que Atendemos</h2>
          <p className="section-description">
            Nuestra experiencia abarca una amplia gama de industrias, cada una con necesidades específicas 
            que atendemos con soluciones personalizadas.
          </p>
          
          <div className="clientes-sectores-grid">
            {sectores.map((sector, idx) => (
              <div key={idx} className="clientes-sector-card">
                <div className="clientes-sector-icon">{sector.icon}</div>
                <h3 className="clientes-sector-nombre">{sector.nombre}</h3>
                <p className="clientes-sector-descripcion">{sector.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué nos eligen */}
      <section className="clientes-beneficios-section">
        <div className="container">
          <h2 className="section-title">¿Por qué nos eligen?</h2>
          <div className="clientes-beneficios-grid">
            {beneficios.map((beneficio, idx) => (
              <div key={idx} className="clientes-beneficio-item">
                <h3>{beneficio.titulo}</h3>
                <p>{beneficio.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="clientes-cta-section">
        <div className="container">
          <h2 className="clientes-cta-title">Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos</h2>
          <Button 
            size="lg" 
            className="clientes-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Clientes;
